var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10473 1.87629C8.13329 1.72336 8.21444 1.58524 8.33413 1.48584C8.45381 1.38644 8.60448 1.33203 8.76006 1.33203C8.91564 1.33203 9.06631 1.38644 9.186 1.48584C9.30568 1.58524 9.38683 1.72336 9.41539 1.87629L10.1161 5.58163C10.1658 5.84506 10.2938 6.08737 10.4834 6.27694C10.673 6.46651 10.9153 6.59453 11.1787 6.64429L14.8841 7.34496C15.037 7.37353 15.1751 7.45468 15.2745 7.57436C15.3739 7.69404 15.4283 7.84472 15.4283 8.00029C15.4283 8.15587 15.3739 8.30655 15.2745 8.42623C15.1751 8.54591 15.037 8.62706 14.8841 8.65563L11.1787 9.35629C10.9153 9.40606 10.673 9.53408 10.4834 9.72365C10.2938 9.91322 10.1658 10.1555 10.1161 10.419L9.41539 14.1243C9.38683 14.2772 9.30568 14.4154 9.186 14.5147C9.06631 14.6141 8.91564 14.6686 8.76006 14.6686C8.60448 14.6686 8.45381 14.6141 8.33413 14.5147C8.21444 14.4154 8.13329 14.2772 8.10473 14.1243L7.40406 10.419C7.3543 10.1555 7.22628 9.91322 7.03671 9.72365C6.84714 9.53408 6.60483 9.40606 6.34139 9.35629L2.63606 8.65563C2.48313 8.62706 2.345 8.54591 2.24561 8.42623C2.14621 8.30655 2.0918 8.15587 2.0918 8.00029C2.0918 7.84472 2.14621 7.69404 2.24561 7.57436C2.345 7.45468 2.48313 7.37353 2.63606 7.34496L6.34139 6.64429C6.60483 6.59453 6.84714 6.46651 7.03671 6.27694C7.22628 6.08737 7.3543 5.84506 7.40406 5.58163L8.10473 1.87629Z",
    stroke: "#1271A6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0928 1.33398V4.00065",
    stroke: "#1271A6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4264 2.66602H12.7598",
    stroke: "#1271A6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42611 14.6667C4.16249 14.6667 4.75944 14.0697 4.75944 13.3333C4.75944 12.597 4.16249 12 3.42611 12C2.68973 12 2.09277 12.597 2.09277 13.3333C2.09277 14.0697 2.68973 14.6667 3.42611 14.6667Z",
    stroke: "#1271A6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.bfbc611dc661b8350e50be8d301eb0ba.svg";
export { ForwardRef as ReactComponent };